import * as React from "react"

import { cn } from "@/lib/utils"

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "animate-pulse rounded-base bg-secondary-bg border-2 border-nb-border/30",
        className,
      )}
      {...props}
    />
  )
}

export { Skeleton }
